module.exports = __webpack_public_path__ + "img/Yotta-start_spinner.171895.svg";